import { Box, useTheme } from "@mui/material";
import React from "react";

/**
 * ResizeHandle Component - Draggable handle for resizing PDF panel
 * Provides visual feedback and cursor changes during resize operations
 */
const ResizeHandle = ({ isResizing, onMouseDown }) => {
  const theme = useTheme();
  const borderColor = theme.brand.gray.gainsboro;
  return (
    <Box
      onMouseDown={onMouseDown}
      sx={{
        width: "8px",
        cursor: "col-resize",
        backgroundColor: isResizing ? "#2196f3" : "transparent",
        borderLeft: `1px solid ${borderColor}`,
        borderRight: `1px solid ${borderColor}`,
        position: "relative",
        zIndex: 10,
        transition: "background-color 0.2s ease",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "3px",
          height: "30px",
          backgroundColor: "#bbb",
          borderRadius: "2px",
        },
      }}
    />
  );
};

export default ResizeHandle;
